import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailSummaryPrintButton,
} from "../../../../components/detailLayout";
import React, {useEffect, useState} from "react";
import {
    getIncident,
    getIncidentReport,
    updateIncidentReport,
} from "../../../../api/maintenance/IncidentService";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {selectHandlers} from "../../../../api/handler/handlerService";
import {skeleton} from "../../../../redux/slice/apiSlice";
import SignContainer from "../../../../components/basic/SignContainer";
import {getContentStatus} from "../../../../api/contentStatus/contentStatusService";
import {IncidentRequestInfoPanel, IncidentReportBodyPanel} from "./incidentReportPanels";

function IncidentReportUpdate() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [incident, setIncident] = useState({});
    const [handler, setHandler] = useState([]);
    const [assets, setAssets] = useState([]);
    const [incidentReport, setIncidentReport] = useState({});
    const [statusNumericValue, setStatusNumericValue] = useState(0);

    useEffect(() => {
        Promise.all([
            getIncident(id),
            selectHandlers({contentId: id, contentCategory: ContentCategory.INCIDENT}),
            getContentStatus({contentId: id, contentCategory: ContentCategory.INCIDENT}),
        ]).then(([incidentResponse, handlersResponse, statusResponse]) => {
            if (incidentResponse.status === 201) {
                if (incidentResponse.data.errorCode === "AUTHORITY") {
                    alert(incidentResponse.data.reason);
                    navigate(-1);
                }
            }

            setIncident(incidentResponse.data);
            setAssets(incidentResponse.data.maintenanceAssets?.map((each) => each.assets) ?? []);
            setHandler(handlersResponse.data);

            if (statusResponse?.status === 200) {
                setStatusNumericValue(statusResponse.data.statusNumericValue);
            }

            getIncidentReport(id).then((reportResponse) => {
                if (reportResponse.status !== 200 || !reportResponse.data?.id) {
                    alert("장애보고서를 찾을 수 없습니다.");
                    navigate(`/maintenance/incident/${id}`);
                    return;
                }
                setIncidentReport(reportResponse.data);
            });
        }).finally(() => dispatch(skeleton(false)));
    }, [id, dispatch, navigate]);

    const update = async () => {
        const data = {
            ...incidentReport,
            incident: {id: incident.id},
        };

        const response = await updateIncidentReport(data);
        if (response.status === 200) {
            alert("수정되었습니다.");
            navigate(`/maintenance/incident/${incident.id}`);
        }
    };

    if (Object.keys(incidentReport).length === 0 || Object.keys(incident).length === 0) {
        return null;
    }

    const summaryMeta = [
        incident.incidentCode?.name && `유형 ${incident.incidentCode.name}`,
        incident.requester?.name && `요청 ${incident.requester.name}`,
    ].filter(Boolean).join(" · ");

    return (
        <ContentDetailInfoShell
            title={incident?.title || "장애보고서 수정"}
            meta={summaryMeta || undefined}
            contentId={incident.id}
            contentCategory={ContentCategory.INCIDENT}
            scrollMode="columns"
            actions={<DetailSummaryPrintButton />}
            rollup={{
                cancel: {url: `/maintenance/incident/${incident.id}`},
                update: incident.auth?.update && update,
            }}
        >
            <ContentDetailThreeColLayout
                primary={<IncidentRequestInfoPanel incident={incident} assets={assets} handler={handler} />}
                secondary={
                    <IncidentReportBodyPanel
                        incident={incident}
                        incidentReport={incidentReport}
                        setIncidentReport={setIncidentReport}
                    />
                }
                aside={
                    <>
                        <SignContainer
                            contentId={incident.id}
                            contentCategory={"INCIDENT"}
                            statusNumericValue={statusNumericValue}
                        />
                        <DetailFilePanel
                            isEditing={Boolean(incident.auth?.update)}
                            showFileLabel={false}
                            tableInfo={{tableName: "incident_report", joinKey: incidentReport.id}}
                        />
                    </>
                }
            />
        </ContentDetailInfoShell>
    );
}

export {IncidentReportUpdate};
